import React from 'react';
import { Modal } from 'react-bootstrap';
import { Warning48Filled } from '@fluentui/react-icons';
import styles from './DoubleConfirmationModal.module.css';

/**
 * Adjust schedule to new deadline?
 * Step 1: Change deadline only vs Adjust timeline to deadline
 * Step 2+: downstream schedule/deadline (via RecalculateScheduleModal)
 */
const AdjustDeadlineModal = ({
    open,
    onClose,
    onChangeDeadlineOnly,
    onAdjustTimelineToDeadline,
    canAdjustTimeline = true,
    confirmLoading = false,
}) => {
    const runIfIdle = action => {
        if (!confirmLoading) action();
    };

    const linkStyle = {
        opacity: confirmLoading ? 0.6 : 1,
        pointerEvents: confirmLoading ? 'none' : 'auto',
        textAlign: 'center',
    };

    return (
        <Modal centered show={open} onHide={() => !confirmLoading && onClose()} className={styles.modalMainBody}>
            <Modal.Body className={styles.confirmationModalBody}>
                <div className={styles.confirmationModalMsg}>
                    <div className="mb-4 text-center">
                        <Warning48Filled color="var(--Brand-Primary)" />
                    </div>
                    <h3 style={{ textAlign: 'center', fontSize: 20, fontWeight: 600, marginBottom: 16 }}>
                        Adjust schedule to new deadline?
                    </h3>
                    <p className={styles.message} style={{ marginBottom: 34 }}>
                        You changed this task&apos;s Deadline. Would you like to change the Deadline only, or adjust the
                        Timeline so the task finishes by the new Deadline?
                    </p>
                    {!canAdjustTimeline && (
                        <p className={styles.message} style={{ marginBottom: 16, fontSize: 13, color: '#5A5F7A' }}>
                            Add a Duration before adjusting the Timeline to this Deadline.
                        </p>
                    )}
                    <div className="d-flex flex-column gap-3">
                        <span
                            role="button"
                            tabIndex={0}
                            onClick={() => runIfIdle(onChangeDeadlineOnly)}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') runIfIdle(onChangeDeadlineOnly);
                            }}
                            className={styles.orangeLink}
                            style={linkStyle}>
                            Change deadline only
                        </span>
                        <span
                            role="button"
                            tabIndex={canAdjustTimeline ? 0 : -1}
                            onClick={() => canAdjustTimeline && runIfIdle(onAdjustTimelineToDeadline)}
                            onKeyDown={e => {
                                if (canAdjustTimeline && (e.key === 'Enter' || e.key === ' ')) {
                                    runIfIdle(onAdjustTimelineToDeadline);
                                }
                            }}
                            className={styles.orangeLink}
                            style={{
                                ...linkStyle,
                                opacity: canAdjustTimeline ? linkStyle.opacity : 0.45,
                                pointerEvents: canAdjustTimeline ? linkStyle.pointerEvents : 'none',
                            }}>
                            Adjust timeline to deadline
                        </span>
                        <span
                            role="button"
                            tabIndex={0}
                            onClick={() => runIfIdle(onClose)}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') runIfIdle(onClose);
                            }}
                            className={styles.secondaryLink}
                            style={linkStyle}>
                            Cancel
                        </span>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default AdjustDeadlineModal;
